const VERTICAL_TRAVERSAL_CATEGORY = ["elevator", "escalator", "stairs", "ramp"]
const VERTICAL_KIOSK_BREAKPOINT = "@media (min-height:1920px)"

const Q_AUTOPLAY = "autoplay"
const Q_PARENT_CATEGORY_ID = "parentCategoryId"
const Q_SUB_CATEGORY_ID = "subCategoryId"
const Q_ORDINAL = "ordinal"
const Q_VENUE = "venue"

const PROMOTION_TAXONOMY = "promotion-category"

const GTM_SEARCH_KEYWORD = "search_keyword"
const GTM_CATEGORY_QUICK_SEARCH = "category_quick_search"
const GTM_GET_DIRECTION = "get_direction"
const GTM_VIEW_EVENT_DETAIL = "view_event_detail"
const GTM_AMENITY_SEARCH = "amenity_search"
const GTM_VIEW_PROMOTION_DETAIL = "view_promotion_detail"
const GTM_VIEW_FEATURE_DETAIL = "view_feature_detail"
const GTM_VIEW_DIRECTORY_CATEGORY = "view_directory_category"
const GTM_NO_RESULT_VALUE = "no result"
const GTM_PROMOTION_LOCATION = "view_promotion_location"
const GTM_EVENT_LOCATION = "view_event_location"
const GTM_VIEW_DINING_CATEGORY = "view_dining_category"
const GTM_COUNT_KIOSK_USERS = "count_kiosk_users"

export {
  PROMOTION_TAXONOMY,
  VERTICAL_TRAVERSAL_CATEGORY,
  VERTICAL_KIOSK_BREAKPOINT,
  Q_AUTOPLAY,
  Q_PARENT_CATEGORY_ID,
  Q_SUB_CATEGORY_ID,
  Q_ORDINAL,
  Q_VENUE,
  GTM_SEARCH_KEYWORD,
  GTM_CATEGORY_QUICK_SEARCH,
  GTM_GET_DIRECTION,
  GTM_VIEW_EVENT_DETAIL,
  GTM_AMENITY_SEARCH,
  GTM_VIEW_PROMOTION_DETAIL,
  GTM_VIEW_FEATURE_DETAIL,
  GTM_VIEW_DIRECTORY_CATEGORY,
  GTM_NO_RESULT_VALUE,
  GTM_PROMOTION_LOCATION,
  GTM_EVENT_LOCATION,
  GTM_VIEW_DINING_CATEGORY,
  GTM_COUNT_KIOSK_USERS,
}
